import React, { memo } from "react";
import { config } from "../../../config";
import { buildRouteWithParams } from "../../../helpers/build-route-with-params";
import { Route, Switch } from "react-router-dom";
import { ConfirmationValidation } from "../confirmation-validation/confirmation-validation";
import { ConfirmationLayout } from "../confirmation-layout";
import { RefreshOnPayment } from "../refresh-on-payment/refresh-on-payment";

const Confirmation = () => {
  return (
    <>
      <Switch>
        <Route
          exact={true}
          path={`${buildRouteWithParams(config.routes.confirmation, false)}`}
        >
          <ConfirmationLayout />
        </Route>
        <Route
          exact={true}
          path={buildRouteWithParams(
            config.routes.confirmationOnRefresh,
            false
          )}
        >
          <RefreshOnPayment />
        </Route>
        <Route
          exact={true}
          path={buildRouteWithParams(config.routes.confirmationEnd, false)}
        >
          <ConfirmationValidation />
        </Route>
      </Switch>
    </>
  );
};
export const ConfirmationRouter = memo(Confirmation);
